import { styled } from 'goober';

import { CompanySelectionView } from '@/features/enhance-common/components/company-selection-view';
import { companyFilterSortState } from '@/features/enhance-common/constants/enhance.constants';
import { useCompanySelectionTable } from '@/features/enhance-common/hooks/use-company-selection-table';
import { OverflowContainer } from '@/features/enhance-common/styles/enhance-modal.styles';
import { mediaQuery } from '@/theme/setupTheme';

import { useProjectListingSuggestionState } from '../use-project-listing-suggestion.state';

const TABLE_HEIGHT_SM = 'min(280px, 35vh)';
const TABLE_HEIGHT_MD = 'min(350px, 42vh)';
const TABLE_HEIGHT_LG = '410px';

const ScrollableWrapper = styled(OverflowContainer)`
  --company-table-height: ${TABLE_HEIGHT_SM};
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow-x: auto;

  ${mediaQuery('md', 'min')} {
    --company-table-height: ${TABLE_HEIGHT_MD};
  }

  ${mediaQuery('lg', 'min')} {
    --company-table-height: ${TABLE_HEIGHT_LG};
  }
`;

export const CompanySelectionViewWrapper = () => {
  const state = useProjectListingSuggestionState();

  const { headers, rows } = useCompanySelectionTable({
    isAllSelected: state.isAllCompaniesSelected,
    isInverted: false,
    onSelectAll: state.setCompanyFilterSelectAll,
    onToggle: state.toggleCompanyFilterSelected,
    projectListings: state.projectListings,
    selectedCompanies: state.companyFilterSelected,
    totalCount: state.totalListingsCount,
  });

  return (
    <ScrollableWrapper
      data-testid="company-selection-view-wrapper"
      direction="column"
      gap="8px"
      name="company-selection-wrapper"
    >
      <CompanySelectionView
        dataTestId="company-selection-view"
        fetchNextPage={state.fetchNextPage}
        hasNextPage={state.hasNextPage}
        headers={headers}
        isFetchingNextPage={state.isFetchingNextPage}
        onSearchChange={state.setCompanySearch}
        projectListings={state.projectListings || []}
        rows={rows}
        searchValue={state.companySearch}
        sortState={companyFilterSortState}
        tableHeight="var(--company-table-height)"
      />
    </ScrollableWrapper>
  );
};
